import React from 'react';
import { testimonials } from '../data/ebook';
import { Section } from './Section';
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <Section id="resultados" className="bg-white" data-id="element-170" data-mp="3fznujnjr7f2f">
      <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage-dark" data-id="element-171" data-mp="3fycqrnqb67bb">
        Lo que dicen quienes ya lo hicieron
      </p>

      <div className="mt-10 grid gap-10 lg:grid-cols-[1.3fr_1fr] lg:gap-16" data-id="element-172" data-mp="3ayqbl8qx6gzv">
        <figure className="flex flex-col border-t-0 border-l-2 border-sage pl-6 sm:pl-8" data-id="element-173" data-mp="370al2uvmqqhp">
          <blockquote className="font-display text-3xl font-light leading-snug text-ink sm:text-4xl" data-id="element-174" data-mp="31ybgxis2fpjp">
            «{featured.quote}»
          </blockquote>
          <figcaption className="mt-auto pt-8 text-sm" data-id="element-175" data-mp="2s28c255txct2">
            <span className="font-semibold text-ink" data-id="element-176" data-mp="2s3t9c2jj39um">{featured.name}</span>
            <span className="text-muted" data-id="element-177" data-mp="v8555k5bgowg"> · {featured.detail}</span>
            <span className="mt-3 block text-xs font-semibold uppercase tracking-[0.16em] text-sage-dark" data-id="element-178" data-mp="q9u15q1pd8m5">
              {featured.result}
            </span>
          </figcaption>
        </figure>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-1" data-id="element-179" data-mp="m5klin0mcrbw">
          {rest.map(item => <figure key={item.name} className="flex h-full flex-col border-t border-line pt-6" data-id="element-180" data-mp="78aepqyx89mi">
              <blockquote className="text-[15px] leading-relaxed text-muted" data-id="element-181" data-mp="c6buo311vstr">
                «{item.quote}»
              </blockquote>
              <figcaption className="mt-auto pt-5 text-sm" data-id="element-182" data-mp="zwy3hwivph4t">
                <span className="font-semibold text-ink" data-id="element-183" data-mp="14w28eayrsspc">{item.name}</span>
                <span className="text-muted" data-id="element-184" data-mp="q6mmb8a6pbfz"> · {item.detail}</span>
                <span className="mt-2 block text-xs font-semibold uppercase tracking-[0.16em] text-sage-dark" data-id="element-185" data-mp="q6cudf5kwu7n">
                  {item.result}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>

      <p className="mt-12 text-xs leading-relaxed text-muted" data-id="element-186" data-mp="1nmk0cdbs3k9n">
        Los resultados varían según la persona. No se garantizan resultados específicos.
      </p>
    </Section>;
}